<script setup lang="ts">
import { LANDING_CONTENT } from '~/utils/constants'
const companies = LANDING_CONTENT.SOCIAL_PROOF
</script>

<template>
  <div
    class="py-10 border-y border-gray-100 dark:border-gray-800/50 bg-white/50 dark:bg-gray-900/50 backdrop-blur-sm overflow-hidden"
  >
    <UContainer>
      <p class="text-center text-sm font-medium text-gray-500 dark:text-gray-400 mb-8">
        Trusted by students from
      </p>

      <div class="relative flex overflow-x-hidden group">
        <!-- Gradient Masks -->
        <div
          class="absolute inset-y-0 left-0 w-20 bg-gradient-to-r from-white dark:from-gray-950 to-transparent z-10"
        ></div>
        <div
          class="absolute inset-y-0 right-0 w-20 bg-gradient-to-l from-white dark:from-gray-950 to-transparent z-10"
        ></div>

        <!-- Marquee Content -->
        <div class="animate-marquee flex space-x-16 whitespace-nowrap py-2">
          <template v-for="i in 4" :key="i">
            <!-- Repeat 4 times for seamless loop -->
            <div class="flex items-center gap-16">
              <div
                v-for="company in companies"
                :key="company"
                class="flex items-center gap-2 opacity-40 hover:opacity-80 transition-opacity duration-300 grayscale hover:grayscale-0"
              >
                <UIcon :name="`i-simple-icons-${company.toLowerCase()}`" class="w-6 h-6" />
                <span class="text-xl font-bold font-display">{{ company }}</span>
              </div>
            </div>
          </template>
        </div>
      </div>
    </UContainer>
  </div>
</template>

<style scoped>
.animate-marquee {
  animation: marquee 30s linear infinite;
}

@keyframes marquee {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}
</style>
